/**
 * Initial image index for a freshly-loaded cornerstone STACK.
 *
 * Defaults to the middle frame (radiologist expectation when opening a
 * multi-frame stack), but honors an explicit pending navigation target when one
 * is set — e.g. a report finding-jump whose `pendingJump` is seeded into the
 * slot by the cross-series `SET_SERIES` swap. Without this the weak-GPU
 * StackViewport fallback snaps to the middle slice and the finding-jump target
 * is silently lost (it only bit when the finding's series wasn't already
 * displayed; same-series jumps skip the stack reload). VolumeViewport is
 * unaffected — it honors the target via its own jump machinery.
 *
 * `pendingJump` is the slot's *jump target*, distinct from its current
 * `sliceIndex`: a `SET_SERIES` swap resets `sliceIndex` to 0, so keying off the
 * current index would wrongly start every swap at slice 0. Only a real pending
 * target overrides the middle default.
 */
export function resolveStackStartIndex(
  pendingJump: number | null | undefined,
  totalImages: number,
): number {
  if (totalImages <= 0) return 0;
  if (
    typeof pendingJump === "number" &&
    Number.isInteger(pendingJump) &&
    pendingJump >= 0 &&
    pendingJump < totalImages
  ) {
    return pendingJump;
  }
  return Math.floor(totalImages / 2);
}
